import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const subjectReducer = (state: RootState) => state.subject;

export const subjectSubjectsSelector = createSelector(
	subjectReducer,
	(state) => {
		return state.subjects;
	}
);

export const legaleRappresentanteSelector = createSelector(
	subjectReducer,
	(state) => {
		return state.subjects?.legaleRapp;
	}
);

export const elencoTitolariEffettiviSelector = createSelector(
	subjectReducer,
	(state) => {
		return state.subjects?.elencoTitolariEffettivi;
	}
);

export const titolariEffettiviAddedSelector = createSelector(
	subjectReducer,
	(state) => {
		return state.titolariEffettiviAdded;
	}
);

export const subjectSelector = createSelector(subjectReducer, (state) => {
	return state.subject;
});

export const subjectIdLegaleRappresentanteSelector = createSelector(
	subjectReducer,
	(state) => {
		return state.idLegaleRappresentante;
	}
);
